import { ReactElement } from 'react';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { JobHeaderContainer } from '../../../../modules/jobs/containers/details/JobHeader.container';
import { JobTabsContainer } from '../../../../modules/jobs/containers/details/JobTabs.container';
import { JOB_TYPE } from '../../../../modules/jobs/jobs.model';
import { InferenceDetailsCreateRoute, InferenceDetailsRoute } from '../../../routes/inferences/inferenceDetails.route';

export const InferenceDetailsView = (): ReactElement => {
  return (
    <DashboardContainer>
      <JobHeaderContainer jobType={JOB_TYPE.INFERENCE} />
      <ColumnLayout size='none'>
        <JobTabsContainer />
        <InferenceDetailsRoute />
      </ColumnLayout>
    </DashboardContainer>
  );
};

export const InferenceDetailsCreateView = (): ReactElement => {
  return (
    <DashboardContainer>
      <JobHeaderContainer jobType={JOB_TYPE.INFERENCE} />
      <ColumnLayout size='none'>
        <JobTabsContainer />
        <InferenceDetailsCreateRoute />
      </ColumnLayout>
    </DashboardContainer>
  );
};
